<template>
  <div class="detail-div">
    <CRow>
      <div>
        <CModal :title="submitType === 'Update' ? $lang.post.crud.edit : $lang.common.general.reason" size="lg"
          :show.sync="largeModal" :no-close-on-backdrop="true" color="primary">
          <CCardBody>
            <CRow>
              <CCol md="12">
                <c-textarea v-model="post.reason" :rows="5" :cols="10" placeholder="Add Reason"></c-textarea>
              </CCol>
              <CCol md="6">
                <div class="form-group">
                  <CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.submit" :disabled="submitted"
                    v-on:click="blockPost(statusId)">
                    Submit
                  </CButton>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
          <template #footer style="display: none">
            <CButton @click="darkModal = false" color="danger" style="display: none">Discard</CButton>
            <CButton @click="darkModal = false" color="success" style="display: none">Accept</CButton>
          </template>
        </CModal>
      </div>
    </CRow>
    <CRow>
      <CCol md="12" class="align-self-center">
        <CRow>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.recruitments.detail.company }}
            </p>
            <p class="custome-detail">
<!--              <profiler-detail :username="recruitments.company" :profilerId="recruitments.userId"></profiler-detail>-->
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Job Title
            </p>
            <p class="custome-detail">
              {{ recruitments.job_title }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Hiring For
            </p>
            <p class="custome-detail">
              {{ recruitments.hire_for }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Client
            </p>
            <p class="custome-detail">
              {{ recruitments.client }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Job Type
            </p>
            <p class="custome-detail">
              {{ recruitments.job_type }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Employment Type
            </p>
            <p class="custome-detail">
              {{ recruitments.employment_type }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Mode Of Work
            </p>
            <p class="custome-detail">
              {{ recruitments.work_type }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Tentative Joining Date
            </p>
            <p class="custome-detail">
              {{ recruitments.dates }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              No of Openings
            </p>
            <p class="custome-detail">
              {{ recruitments.no_of_opening }}
            </p>
          </CCol>

          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Summary
            </p>
            <p class="custome-detail">
              {{ recruitments.description }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Industry
            </p>
            <p class="custome-detail">
              {{ recruitments.industry }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Recent Skills
            </p>
            <p class="custome-detail">
              {{ recruitments.recent_skills }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Other Skills
            </p>
            <p class="custome-detail">
              {{ recruitments.other_skills }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Education Qualification
            </p>
            <p class="custome-detail">
              {{ recruitments.education }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Min Experience
            </p>
            <p class="custome-detail">
              {{ recruitments.experience }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Max Experience
            </p>
            <p class="custome-detail">
              {{ recruitments.max_experience }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Currency
            </p>
            <p class="custome-detail">
              {{ recruitments.currency }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Min CTC / Year
            </p>
            <p class="custome-detail">
              {{ recruitments.budget }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Max CTC / Year
            </p>
            <p class="custome-detail">
              {{ recruitments.max_budget }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Hire Based On
            </p>
            <p class="custome-detail">
              {{ recruitments.hire_based_on }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Company Name
            </p>
            <p class="custome-detail">
                <img width="50px" :src="mediadetail" />{{ recruitments.owner_name }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Company Contact Number
            </p>
            <p class="custome-detail">
              {{ recruitments.owner_contact }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Company Email
            </p>
            <p class="custome-detail">
              {{ recruitments.owner_email }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Contact Person Name
            </p>
            <p class="custome-detail">
              {{ recruitments.contact_name }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Contact Person Email
            </p>
            <p class="custome-detail">
              {{ recruitments.contact_email }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Company Summary
            </p>
            <p class="custome-detail">
              {{ recruitments.company_summary }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Publish to Candidate
            </p>
            <p class="custome-detail">
              {{ publish_to_candidate == 1 ? 'Yes' : 'No' }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4" v-show="publish_to_candidate == 1">
            <p class="custome-labal">
              Referral Bonus
            </p>
            <p class="custome-detail">
              {{ referral_bonus }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              Publish to recruiter
            </p>
            <p class="custome-detail">
              {{ publish_to_recruiter == 1 ? 'Yes' : 'No' }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4" v-show="publish_to_recruiter == 1">
            <p class="custome-labal">
              Commission
            </p>
            <p class="custome-detail">
              {{ commission }}
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.recruitments.detail.status }}</p>
            <p class="custome-detail">
              <CBadge :color="statusBudget(post.isStatus)">{{ post.isStatus }}</CBadge>
            </p>
          </CCol>
        </CRow>
        <hr>
        <h4>Job Locations</h4>
        <CRow>
          <CCol md="12">
            <table class="table table-bordered">
              <tr>
                <th>Country</th>
                <th>City</th>
              </tr>
              <tr v-for="(bottom,index) in bottomMenuList">
                <td>
                  {{bottom.selected.label}}
                </td>
                <td>
                  <span v-for="(ci) in bottom.city">
                    {{ci.label}}, &nbsp;
                  </span>
                </td>
              </tr>
            </table>
          </CCol>
          <CCol md="6">
            <span v-for="(item, index) in media">
              <img width="100px" :src="item.url" /> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </CCol>
        </CRow>
        <EntityTimeStamp
            :createdAt="recruitments.createdAt"
            :updatedAt="recruitments.updatedAt"
            :createdBy="recruitments.firstName"
            :avatar="recruitments.avatar"
        ></EntityTimeStamp>

        <CRow v-show="recruitments.blockedReason">
          <CCol sm="12" align="left">
            <strong>Blocked Reason: </strong> {{ recruitments.blockedReason }}
          </CCol>
        </CRow>

        <CRow v-if="!recruitments.blockedReason">
          <CCol sm="12" align="left">
            <CButton
                :color="statusColor"
                v-c-tooltip="statusLabel"
                v-on:click="beforeBlocked()"
            >
              {{ statusLabel }}
            </CButton>
          </CCol>
        </CRow>

      </CCol>
    </CRow>
  </div>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import {Recruitments} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import VueNotifications from "vue-notifications";
import ProfilerDetail from "/src/views/ProfilerDetail.vue";
import EntityTimeStamp from "/src/components/EntityTimeStamp";
import store from "../../../store/store";

Vue.use(VueNotifications);
Vue.use(VueForm);

export default {
  name: "DetailsTab",
  mixins: [Mixin],
  components: {
    ProfilerDetail,
    EntityTimeStamp
  },
  data() {
    return {
      statusLabel: "Block",
      statusColor: "danger",
      selectedColumns: [],
      iAmUser: "",
      userId: "",
      listUrl: "",
      list: [],
      publish_to_candidate : "",
      referral_bonus : "",
      publish_to_recruiter : "",
      commission : "",
      statusOption: [
        {value: "1", label: "Active"},
        {value: "0", label: "InActive"},
        {value: "2", label: "Block"}
      ],
      experienceList: [],
      commissionTypeList: [],
      workTypeList: [],
      availabilityList: [],
      currencyList: [],
      jobTypeList: [],
      json_data: [],
      json_label: {},
      media : [],
      mediadetail : "",
      json_title: "",
      toggleFilterValue: false,
      range: [0, 1000000],
      number: 1,
      bottomMenuList: [],
      err_msg: "",
      largeModal: false,
      submitted: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      requirement: [],
      worktype: [],
      experience: '',
      activePage: 1,
      module: Recruitments,
      recruitments: {},
      citys: [],
      post: {
        reason: "",
        isActive: "",
      }
    }
  },
  mounted() {
    let self = this;
    const id = this.$route.params.id;
    store.commit("showLoader", false);
    axios.get('job-opening/view/' + id).then((response) => {
      if (response) {
        let responseData = response.data.data;
        self.recruitments.blockedReason = responseData.blockedReason;
        self.recruitments.hire_for =  responseData.hiringFor;
        self.recruitments.industry = responseData.industry.title;
        self.recruitments.job_title = responseData.title;
        self.recruitments.client = responseData.clientName;
        self.recruitments.job_type = responseData.jobType;
        self.recruitments.company_summary = responseData.companySummary;
        self.recruitments.contact_email = responseData.companyEmail;
        self.recruitments.contact_name = responseData.contactPerson;
        self.recruitments.employment_type = responseData.employmentType;
        self.recruitments.work_type = responseData.workMode;
        self.recruitments.dates = responseData.joiningDate;
        self.recruitments.no_of_opening = responseData.noOfOpenings;
        self.recruitments.description = responseData.description;
        self.media = responseData.media;
        self.mediadetail = responseData.mediaurl;
        self.publish_to_candidate = responseData.jobCandidatePublish?.jobStatusId;
        self.referral_bonus = responseData.jobCandidatePublish?.referralBonus;
        self.publish_to_recruiter = responseData.jobRecruiterPublish?.jobStatusId;
        self.commission = responseData.jobRecruiterPublish?.commission;
        const j = [];
        responseData.skills.map(function (value, key) {
          j.push(value.title);
        });
        self.recruitments.recent_skills = j.join(", ");

        const p = [];
        responseData.otherSkills.map(function (value, key) {
          p.push(value.title);
        });
        self.recruitments.other_skills = p.join(", ");

        const list = [];
        responseData.education.map(function (value, key) {
          list.push(value.title);
        });
        self.recruitments.education = list.join(", ");
        self.recruitments.experience = responseData.minExperience;
        self.recruitments.max_experience = responseData.maxExperience;
        self.recruitments.currency = responseData.currency.name;
        self.recruitments.budget = responseData.minSalary;
        self.recruitments.max_budget = responseData.maxSalary;
        self.recruitments.hire_based_on = responseData.baseOnHire;
        self.recruitments.owner_name = responseData.companyName;
        self.recruitments.owner_contact = responseData.contactPersonMobileNumber;
        self.recruitments.owner_email = responseData.contactPersonEmail;
        self.bottomMenuList = responseData.bottomMenuList;

        self.post.isStatus = responseData.isActiveStatus ?? '';
        self.isStatus = responseData.isActiveStatus ?? '';
        self.post.isActive = responseData.isActive;
        if (self.post.isStatus === "Active") {
          self.post.isStatus = 'Open';
          self.statusLabel = this.getStatusLabel(2);
          self.statusId = "2";
          self.statusColor = "danger";
        } else {
          self.statusId = "1";
          self.statusLabel = this.getStatusLabel(1);
          self.statusColor = "success";
        }
      } else {
        self.data = [];
      }
    });
  },
  methods: {
    getStatusLabel(getStatus) {
      let valObj = " ";
      valObj = this.statusOption.filter(function (elem) {
        if (elem.value == getStatus) return elem.value;
      });
      if (valObj.length > 0) return valObj[0].label;
    },

    beforeBlocked() {
      let self = this;
      self.post.reason = "";
      if (self.post.isActive === 1) {
        this.largeModal = true;
      } else {
        this.blockPost(self.statusId);
      }
    },

    blockPost(statusId) {
      let self = this;
      self.submitted = true; //Enable Button
      if (self.post.isActive == 1) {
        console.log(self.post.reason);
        if (self.post.reason === "") {
          self.submitted = false; //Enable Button
          return false;
        }
        this.$swal({
          title: this.$lang.common.status.want_to_block,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#e55353",
          confirmButtonText: this.$lang.common.status.yes_block,
          cancelButtonText: this.$lang.common.status.cancel,
        }).then((result) => {
          if (result.value) {
            const id = this.$route.params.id;

            setTimeout(() => {
              let self = this;
              const postData = {
                status: statusId,
                reason: self.post.reason,
              };
              let status, button;
              if (self.statusId === "1") {
                self.statusId = "2";
                self.statusColor = "danger";
                status = this.getStatusLabel(1);
                button = "Block";
              } else {
                self.statusId = "1";
                self.statusColor = "success";
                status = "Blocked";
                button = this.getStatusLabel(1);
              }

              axios
                  .post(this.statusUrlWeb(this.module, id), postData)
                  .then(function (response) {
                    if (response.data.code === 200) {
                      self.post.isStatus = status;
                      self.statusLabel = button;
                      self.largeModal = false;
                      self.submitted = false; //Enable Button
                      self.$router.go();
                    } else {
                      self.err_msg = response.data.message;
                      self.dismissCountDown = 10;
                    }
                  })
                  .catch(function (error) {
                    self.submitted = false; //Enable Button
                  });
            }, 500);
          }
        });
      } else {
        let self = this;
        const id = this.$route.params.id;
        const postData = {
          status: statusId,
          reason: null,
        };
        let status, button;
        if (self.statusId === "1") {
          self.statusId = "2";
          self.statusColor = "danger";
          status = this.getStatusLabel(1);
          button = "Block";
        } else {
          self.statusId = "1";
          self.statusColor = "success";
          status = "Blocked";
          button = this.getStatusLabel(1);
        }
        axios
            .post(this.statusUrlWeb(this.module, id), postData)
            .then(function (response) {
              if (response.data.code === 200) {
                self.post.isStatus = status;
                self.statusLabel = button;
                self.largeModal = false;
                self.submitted = false; //Enable Button
                self.$router.go();
              } else {
                self.err_msg = response.data.message;
                self.dismissCountDown = 10;
              }
            })
            .catch(function (error) {
              self.submitted = false; //Enable Button
            });
      }
    },
  },
};
</script>
